/* unplugin-vue-components disabled */import script from "./Component2.vue?vue&type=script&setup=true&name=Component2&lang=js"
export * from "./Component2.vue?vue&type=script&setup=true&name=Component2&lang=js"

import "./Component2.vue?vue&type=style&index=0&id=4e04925d&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e04925d"]])

export default __exports__